// used to determine how many decks a vehicle has in the wagon create/edit view
export class FloorType{
    id:number;
    name:string;
}